import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LookupModalService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getLookup(params: object) {
    return this.http.post("/Office/getLookup", params).toPromise();
  }
}
